import { render, staticRenderFns } from "./salesOrderAdd.vue?vue&type=template&id=044b25a8&scoped=true"
import script from "./salesOrderAdd.vue?vue&type=script&lang=js"
export * from "./salesOrderAdd.vue?vue&type=script&lang=js"
import style0 from "./salesOrderAdd.vue?vue&type=style&index=0&id=044b25a8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044b25a8",
  null
  
)

export default component.exports